<template>
  <div id="app" v-cloak>
    <!-- <Ioading v-show="!apparent" /> -->
    <router-view></router-view>
  </div>
</template>

<script>
import Ioading from '@/components/Ioading'
export default {
  name: 'App',
  data() {
    return {
      apparent:false,
      Link:{
        page:1,
        limit:100,
      },
    }
  },
  components:{
    Ioading
  } ,
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
    setTimeout(function() {
      this.apparent = true;
    }.bind(this), 3000)
    //获取banner
    this.$store.dispatch('shareBbanner',this.Link);
    //获取友情链接
    this.$store.dispatch('PostLink');
    //联系我们
    this.$store.dispatch('PostMain');
    //获取案例
    this.$store.dispatch('PostCate');
    //获取首页手风琴
    this.$store.dispatch('PostBanner1');
  },
}
</script>

<style>
  #app{
    overflow: hidden;
  }
  [v-cloak] {
      display: none;
  }
  .nrk{
    width: 1500px;
    margin: 0 auto;
  }
  .nark{
    width: 100%;
    min-width: 1500px;

  }
  .Servic{
        text-align: center;
        margin-top: 30px;
        margin-bottom: 30px;
  }
  .Servic p{
        font-size: 26px;
        padding: 18px 0;
        display: block;
        font-weight: bold;
  }
  .Servic span{
        font-size: 18px;
        line-height: 30px;
        display: block;
  }
  .Servic img{
    display: block;
    margin: 0 auto;
  }
  .bottom-btn{
    overflow: hidden;
    margin-bottom: 26px;
  }
  .hs{
    color: #0019a7;
  }
  .img-in{
    width: 100%;
  }
  .detecti-text{
    width: 1200px;
  }
  .detecti img{
    width: 100% !important;
  }
  @media (max-width: 768px){
    .detecti-text,.detecti-mans{
      width: auto !important;
    }
    .noe{
      width: 100% !important;
      margin-bottom: 20px;
    }
    .detecti-mans .noe{
      margin-top: 0 !important;
    }
    .detecti-text span{
      margin-bottom: 20px !important;
      font-size: 14px !important;
    }
    .nrk{
      width:92%;
      margin: 0 auto;
    }
    .nark{
      width: 100%;
      min-width: auto;
    }
    .img-banner{
      width: 160%;
      margin-left: -30%;
    }
  }
</style>
